<template>
    <div class="container-base" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="doc-paper pages page-static" v-if="step == '0'">
            <div class="page-static-inner">
                <h2>{{formatData.request_name}}님께 소개 및 추천글 작성 부탁드립니다.</h2>
                <p>'발급 버튼'을 클릭하면 등록하신 이메일 주소로 원타임 패스워스를 전송합니다.</p>
            </div>
            <div class="text-center">
                <br/>
                <el-button id="resend_secure" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
                           @click="resendSecurekey()">발급하기</el-button>
            </div>
        </div>
        <div class="doc-paper pages page-static" v-else-if="step == '0_1'">
            <div class="page-static-inner">
                <h2>{{formatData.request_name}}님께 소개 및 추천글 작성 부탁드립니다.</h2>
            </div>
            <p style="font-size: 120%;">원타임 패스워드</p>
            <div style="display: inline-block;min-width: 100%;">
                <el-input class="input-md"
                          placeholder=""
                          title="입력 해주세요"
                          ref="secure_key"
                          v-model="secure_key"
                          type="text"></el-input>
            </div>
            <div class="text-center">
                <br/>
                <el-button id="resend_secure" type="success" style="background-color:#fff;border-color:#fff;color:#e3165c"
                           @click="resendSecurekey()">재송신</el-button>
            </div>
            <div class="text-center">
                <br/>
                <el-button id="send-introduction" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
                           @click="$eventHub.$emit('login-info-secure');">인증하기</el-button>
            </div>
        </div>
        <div class="doc-paper pages page-static" v-else-if="step == '1'">
            <div class="page-static-inner">
                <h2>{{formatData.request_name}}님께 소개 및 추천글 작성 부탁드립니다.</h2>
                <p>※한번 전송해도 재송신에 의해서 내용이 변경 될 수 있습니다.</p>
            </div>
            <p style="font-size: 120%;">본인이름:</p>
            <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
                <el-input class="input-md"
                          placeholder="예)홍길동"
                          title="입력 해주세요."
                          ref="intro_name"
                          v-model="formatData.intro_name"
                          type="text"></el-input>
            </div>
            <br/>
            <p style="font-size: 120%;">본인메일주소:</p>
            <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
                {{formatData.intro_email}}
            </div>
            <br/>
            <p style="font-size: 120%;">본인소개:</p>
            <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
                <p style="font-size: 120%;"><el-input class="input-lg"
                                                      placeholder="예)xx대학 xx학과"
                                                      title="입력 해주세요"
                                                      ref="intro_pr"
                                                      v-model="formatData.intro_pr"
                                                      type="text"></el-input>
                </p>
            </div>
            <br/>
            <p style="font-size: 120%;margin-bottom:5px;">소개 및 추천글:<el-button @click="$modal.show('introductionsample-dialog')" type="success">예문에서 추가</el-button></p>
            <div style="display: inline-block;min-width: 100%;">
                <p style="font-size: 100%;text-align:left;">
                    <modal name="introductionsample-dialog"
                           :adaptive="true"
                           :scrollable="true"
                           height="auto">
                        <div class="v--modal-close-top">
                            <el-button @click="$modal.hide('introductionsample-dialog');"
                                       icon="el-icon-close"
                                       type="text"></el-button>
                        </div>
                        <div class="title">예문선택</div>
                        <div class="description">
                            <p>선택한 예문이 추가되었습니다.</p>
                            <p class="attention">선택한 예문으로 현재 입력 내용이 덮어쓰기 됩니다. 주의 해주세요.</p>
                        </div>
                        <ul class="example-sentence">
                            <li v-for="(item, index) in exampleSentences.introduction_statement"
                                v-on:click="formatData.introductionStatement+=item.replace(/<br>/ig, '\n') + '\n';$modal.hide('introductionsample-dialog')"
                                :key="index">
                                <div class="title">{{ index }}</div>
                                <div class="body"
                                     v-html="item"></div>
                            </li>
                        </ul>
                        <div class="text-right">
                            <el-button @click="$modal.hide('introductionsample-dialog')">닫기</el-button>
                        </div>
                    </modal>
                    <el-input type="textarea"
                              :autosize="{minRows: 8, maxRows: 15}"
                              v-model="formatData.introductionStatement"
                    ></el-input>
                </p>
                <p><span style="color:red;">※최대3000자까지 입력가능</span></p>
            </div>
            <br/>
            <div class="text-center">
                <br/>
                <el-button id="send-introduction" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
                           @click="$eventHub.$emit('login-info-confirm');">입력내용 확인</el-button>
            </div>
        </div>
        <div class="doc-paper pages page-static" v-else-if="step == '2'">
            <div class="page-static-inner">
                <h2>{{formatData.request_name}}님께 소개 및 추천글 작성 부탁드립니다.</h2>
                <p>※한번 전송해도 재송신에 의해서 내용이 변경 될 수 있습니다.</p>
            </div>
            <p style="font-size: 120%;">소개 및 추천자성명:</p>
            <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
                {{formatData.intro_name}}
            </div>
            <br/>
            <p style="font-size: 120%;">소개 및 추천자 메일주소:</p>
            <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
                {{formatData.intro_email}}
            </div>
            <br/>
            <p style="font-size: 120%;">소개 및 추천자 자기소개:</p>
            <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
                {{formatData.intro_pr}}
            </div>
            <br/>
            <p style="font-size: 120%;margin-bottom:5px;">소개 및 추천문:</p>
            <div style="display: inline-block;min-width: 100%; ">
                <pre>{{formatData.introductionStatement}}</pre>
            </div>
            <br/>
            <div class="text-center">
                <br/>
                <el-button id="send-introduction" type="success" style="background-color:#FFF;border-color:#FFF;color:#e3165c"
                           @click="returnEdit"><i class="el-icon-d-arrow-left"></i>수정하기</el-button>
                　
                <el-button id="send-introduction" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
                           @click="$eventHub.$emit('introduction-info-send');">소개 및 추천문을 전송</el-button>
            </div>
        </div>
        <div class="doc-paper pages page-static" v-else-if="step == '3'">
            <div class="page-static-inner">
                <h2>{{formatData.request_name}}님의 소개 및 추천글을 입력해 주셔서 감사합니다.</h2>
                <p>※한번 전송해도 재송신에 의해서 내용이 변경 될 수 있습니다.</p>
            </div>
            <br/>
        </div>
    </div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<script>
import LocalDataMixin from '@/mixins/local-data-mixin'
export default {
    props: {
        secureId: {
            type: String
        },
        secureKey: {
            type: String
        }
    },
    mixins: [LocalDataMixin],
    data: function () {
        return {
            saveName: 'introduction',
            qr_image: '',
            formatData: {
                createDate: null,
                intro_name:'',
                intro_email:'',
                request_name:'',
                request_email:'',
                introductionStatement:'',
                intro_pr:''
            },
            fullscreenLoading:false,
            secure_key:'',
            step:'0',
            exampleSentences: {
                // 志望動機
                introduction_statement: {
                    '교수용': '00씨는 저의 학부 세미나 내에서\n00을 배운 학생입니다.재학중에는 00를 전문으로 연구하고\n00점에서 매우 뛰어난 학생이라고 느끼고 있습니다.\n\n00하고00한성격으로  귀사가 채용해 주신다면\n꼭 활약 해주실거라 믿습니다.\n그럼 잘 부탁드립니다.',
                    '알바점장': '00씨는, 저의 00사·00점포에서 00년\n00업무를 본 학생입니다.업무 중에는 00활동에서\n00점으로 매우 뛰어난 학생이라고 느끼고 있습니다.\n\n00하고 00한 성격으로 귀사가 채용해 주신다면\n꼭 활약 해주실거라 믿습니다.\n그럼 잘 부탁드립니다.',
                    '대학원수료': '00군은 제가 지도하고 있는 00학부 00학과에서 우수한 성적을 거두고 있는 학생입니다.\n\n대학원에서도 적극적으로 연구 등에 몰두하고 있으며, 재학중에는 주로 00를 전문적으로 연구하고 있습니다.또 학업 뿐만 아니라 00부에서도 부장으로서 활약을 하고 있어, 학교 축제등에서는 솔선수범하여 학과를 소개 하고 있습니다. 부원들의 평가도 높아 지도를 하고 있는 저로서도 안심하고 맡길 수 있습니다.승부욕이 높으며 밝은 성격으로 동료와 협업도 문제가 없다고 판단하고 있습니다.\n\n그리고 노력가적인 성격으로  귀사가 채용해 주신다면 담당하는 사업에서도 인간성을 충분히 발휘해 나갈 수 있을 것입니다.\n앞으로도 많은 배려 부탁드립니다',
                    '고등학교 은사·동아리 은사': '00군은 제가 예전에 00학교에서 지도를 맡았던 00부의 우수한 학생입니다.\n\n재학중에는 학업도 우수 하였고 00부에서도 부장으로도 활약을 하였습니다.\n00(대회·콩쿠르)등에서는 솔선수범해 부원을 하나로 모아 00를 획득한 실적이 있습니다.\n부원들의 평가도 높아 지도를 하고 있는 저로서도 안심하고 맡길 수 있습니다.\n승부욕이 높으며 밝은 성격으로 동료와 협업도 문제가 없다고 판단하고 있습니다.\n\n그리고 노력가적인 성격으로  귀사가 채용해 주신다면 담당하는 사업에서도 인간성을 충분히 발휘해 나갈 수 있을 것입니다.\n앞으로도 많은 배려 부탁드립니다'
                }
            }
        }
    },
    computed: {},
    methods: {
        introductionStatement: function () {
            return this.formatData.introductionStatement.replace(/<br>/ig, '\n')
        },
        updateFormatData: function (data) {
            console.error("updateFormatData")
            this.formatData = data
            console.error(data)
        },
        loginInfoConfirm: function () {
            this.step = '2'
            console.error(this.formatData.introductionStatement.replace('\n', '<br>'))
        },
        sendIntroduction: function () {
            const app = this
            const formData = new FormData()
            formData.append('secure_id', this.secureId)
            formData.append('secure_key', this.secure_key)
            formData.append('intro_name', this.formatData.intro_name)
            formData.append('intro_pr', this.formatData.intro_pr)
            formData.append('intro_text', this.formatData.introductionStatement)
            formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
            formData.append('version', '2')
            formData.append('reqflg', '2')

            this.$axios
                .post(this.$varuna.endPoints.sendIntroduction, formData, {timeout: 60000})
                .then(function (response) {
                    app.step = '3'
                    app.$message({
                        duration: 0,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `소개 및 추천글 등록을 성공하였습니다.`,
                        type: 'info'
                    })
                })
                .catch(function (error) {
                    console.log(error)
                    app.$message({
                        duration: 0,
                        showClose: true,
                        message: error.response.data+'。입력내용을 확인하시고 다시 입력 해주세요.',
                        type: 'error'
                    })
                }).finally(function () {
                app.fullscreenLoading = false
            })
            this.step = '3'
        },
        returnEdit: function () {
            this.step = '1'
        },
        resendSecurekey: function () {
            const app = this
            const formData = new FormData()
            formData.append('secure_id', this.secureId)
            formData.append('secure_key', this.secure_key)
            formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
            formData.append('version', '2')
            formData.append('reqflg', '2')

            this.$axios
                .post(this.$varuna.endPoints.resendSecurekey, formData, {timeout: 60000})
                .then(function (response) {
                    app.step = '0_1'
                    app.$message({
                        duration: 0,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `원타임 패스워드를 전송 하였습니다.`,
                        type: 'info'
                    })
                })
                .catch(function (error) {
                    app.$message({
                        duration: 0,
                        showClose: true,
                        message: '입력내용을 확인하시고 다시 입력 해주세요.',
                        type: 'error'
                    })
                }).finally(function () {
                app.fullscreenLoading = false
            })
        },
        loginInfoSecure: function () {
            const app = this
            const formData = new FormData()
            formData.append('secure_id', this.secureId)
            formData.append('secure_key', this.secure_key)
            formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
            formData.append('version', '2')
            formData.append('reqflg', '2')

            this.$axios
                .post(this.$varuna.endPoints.secureIntroduction, formData, {timeout: 60000})
                .then(function (response) {
                    app.step = '1'
                    if (!app.formatData.intro_name)
                        app.formatData.intro_name = response.data.intro_name
                    app.formatData.intro_email = response.data.intro_email

                    app.formatData.request_name = response.data.request_name
                    app.formatData.request_email = response.data.intro_email

                    app.$cookies.config(60 * 60,'')
                    app.$cookies.set('_YAGISH_INTROSECURE_LOGIN', app.secure_key, null, null, null)

                    // app.isSended = true
                    app.$message({
                        duration: 0,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `인증성공`,
                        type: 'info'
                    })
                })
                .catch(function (error) {
                    console.log(error)
                    app.$message({
                        duration: 0,
                        showClose: true,
                        message: error.response.data+'.입력내용을 확인하시고 다시 입력 해주세요.',
                        type: 'error'
                    })
                }).finally(function () {
                app.fullscreenLoading = false
            })
        }
    },
    watch: {
        formatData: function () {
        }
    },
    created: function () {
        console.log(this.secureId)
        console.log(this.secureKey)
        if (this.secureKey) {
            this.secure_key = this.secureKey
            this.step = '0_1'
        }
        console.log(this.step)
        var confirm_code  = this.$cookies.get('_YAGISH_INTROSECURE_LOGIN')
        if (confirm_code) {

            const app = this
            const formData = new FormData()
            formData.append('secure_id', this.secureId)
            formData.append('secure_key', confirm_code)
            formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
            formData.append('version', '2')
            formData.append('reqflg', '2')

            this.$axios
                .post(this.$varuna.endPoints.secureIntroduction, formData, {timeout: 60000})
                .then(function (response) {
                    app.step = '1'
                    if (!app.formatData.intro_name)
                        app.formatData.intro_name = response.data.intro_name
                    app.formatData.intro_email = response.data.intro_email

                    app.formatData.request_name = response.data.request_name
                    app.formatData.request_email = response.data.intro_email

                    app.$cookies.config(60 * 60,'')
                    app.$cookies.set('_YAGISH_INTROSECURE_LOGIN', app.secure_key, null, null, null)

                })
                .catch(function (error) {
                    app.$message({
                        duration: 0,
                        showClose: true,
                        message: '엑세스 에러',
                        type: 'error'
                    })
                })
        } else {
            const app = this
            const formData = new FormData()
            formData.append('secure_id', this.secureId)
            formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
            formData.append('version', '2')
            formData.append('reqflg', '2')

            this.$axios
                .post(this.$varuna.endPoints.getRequestIntroduction, formData, {timeout: 60000})
                .then(function (response) {
                    if (!app.formatData.intro_name)
                        app.formatData.intro_name = response.data.intro_name
                    app.formatData.request_name = response.data.request_name
                })
                .catch(function (error) {
                    app.step = '0'
                })

        }
    },
    mounted: function () {},
    beforeMount: function () {
        this.$eventHub.$on('introduction-info-send', this.sendIntroduction)
        this.$eventHub.$on('login-info-confirm', this.loginInfoConfirm)
        this.$eventHub.$on('login-info-secure', this.loginInfoSecure)
        this.$eventHub.$on('format-data-changed', this.updateFormatData)
    },
    destroyed: function () {
        this.$eventHub.$off('introduction-info-send', this.sendIntroduction)
        this.$eventHub.$off('login-info-confirm', this.loginInfoConfirm)
        this.$eventHub.$off('login-info-secure', this.loginInfoSecure)
        this.$eventHub.$off('format-data-changed', this.updateFormatData)
    }
}
</script>
